<template>
  <div class="py-5">
    <div class="container">
      <h1 class="text-center fw-light">{{ $t('how_much_cost') }}</h1>
      <p v-html="$t('how_much_cost_description')"></p>
      <div class="row mt-5 justify-content-md-center text-dark">
        <div class="col-lg-5">
          <p class="text-info text-center">
            {{ $t('our_recommendation') }}
          </p>
          <div class="card animated fadeInUp">
            <div class="card-body pos-relative card-pricing">
              <div class="h1 fw-light text-center text-uppercase">
                {{ $t('basic') }}
              </div>
              <div class="h1 fw-extrabold text-center mb-1 price-text">
                {{ $t('free') }}
              </div>
              <div class="mt-4 pb-5">
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('distribution') }}
                  </div>
                  <div class="pull-right">{{ $t('limited') }}</div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('analytics') }}
                  </div>
                  <div class="pull-right">{{ $t('limited') }}</div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('support') }}
                  </div>
                  <div class="pull-right">{{ $t('limited') }}</div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('live_support') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-times-circle text-muted mr-2"></i>
                  </div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-info">
                    {{ $t('keep_your_rights') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-2"></i>
                  </div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-info">
                    {{ $t('keep_85_royalties') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-2"></i>
                  </div>
                </div>
              </div>
              <div class="text-center get-access-container">
                <router-link :to="getLoginUrl('free')" class="btn btn-primary">
                  {{ $t('apply_now') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <p class="text-info text-center">
            {{ $t('for_professional') }}
          </p>
          <div class="card animated fadeInUp">
            <div class="card-body pos-relative card-pricing">
              <div class="h1 fw-light text-center text-uppercase">
                {{ $t('pro_plan') }}
              </div>
              <div class="text-center mb-1">
                <span class="h1 fw-extrabold price-text">$4.16</span><span class="text-muted">/mo</span>
              </div>
              <div class="mt-4 pb-5">
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('distribution') }}
                  </div>
                  <div class="pull-right">{{ $t('unlimited') }}</div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('analytics') }}
                  </div>
                  <div class="pull-right">{{ $t('advanced') }}</div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('support') }}
                  </div>
                  <div class="pull-right">{{ $t('advanced') }}</div>
                </div>
                <div class="clearfix feature">
                  <b>All free features plus:</b>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('live_support') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-"></i>
                  </div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('unlimited_artists') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-"></i>
                  </div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('presave_campaigns') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-"></i>
                  </div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('playlist_placement_discounts') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-"></i>
                  </div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('express_deliveries') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-"></i>
                  </div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('minimum_withdrawl') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-"></i>
                  </div>
                </div>
                <div class="clearfix feature">
                  <div class="pull-left text-muted">
                    {{ $t('metadata_changes') }}
                  </div>
                  <div class="pull-right">
                    <i class="fa fa-check text-success mr-"></i>
                  </div>
                </div>
              </div>
              <div class="text-center get-access-container">
                <router-link :to="getLoginUrl('pro')" class="btn btn-primary">
                  {{ $t('get_access') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LandingPricing',
  data: function () {
    return {
      isCrawler: false
    }
  },
  methods: {
    getLoginUrl: function (plan) {
      let baseUrl = ''

      if (location.host.match(/free-music-distribution/)) {
        baseUrl = 'https://indiefy.net'
      }

      if (this.isCrawler) {
        return `${baseUrl}/login`
      }

      if (plan === 'free') {
        return `${baseUrl}/login?plan=free`
      } else if (plan === 'pro') {
        return `${baseUrl}/login?plan=pro&next=/upgrade`
      }
    }
  },
  created: function () {
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)

    window.document.title = 'Indiefy | ' + this.$t('pricing_page_title')
    window.$('meta[name="description"]').attr('content', this.$t('pricing_page_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('pricing_page_description'))
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true
    }, 100)
  }
}
</script>
<style lang="scss" scoped>
.main-image {
  position: relative;

  .bar {
    position: absolute;
    top: 50%;
    left: -100%;
    width: 300%;
  }

  .computer {
    position: absolute;
    left: 50%;
    margin-left: -282px;
  }
}

.super {
  font-size: 3em;
}

.features-columns {
  p {
    font-size: 0.9em;
    color: #8E8E91;
  }
}

.feature {
  margin-top: 10px;
}

.get-access-container {
  width: 100%;
  position: absolute;
  bottom: 25px;
  left: 0;
}

.card-pricing {
  min-height: 570px;
}

.price-text {
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPricing.vue